module.exports = __webpack_public_path__ + "img/hw.fe1f2901.webp";